import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postClassifications({ body }) {
  return BaseService.post(REST.CLASSIFICATIONS, body);
}

function putClassifications({ body, id }) {
  return BaseService.put(REST.CLASSIFICATIONS_ID(id), body);
}

function getClassifications(params) {
  return BaseService.get(REST.CLASSIFICATIONS, {
    params: paramsFilter({ params }),
  });
}

function deleteClassifications({ id }) {
  return BaseService.delete(REST.CLASSIFICATIONS_ID(id));
}

export default {
  deleteClassifications,
  getClassifications,
  putClassifications,
  postClassifications,
};
